const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
      width: '66%',
      marginRight: theme.spacing(2),
      justifyContent: 'space-between',
    },
  },
  summary: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      width: '34%',
    },
  },
  titleAddress: {
    margin: theme.spacing(2, 0),
  },
  field: {
    '& .MuiTextField-root': {
      marginBottom: theme.spacing(3) / 2,
    },
  },
  fields: {
    '& .MuiTextField-root': {
      marginBottom: theme.spacing(3) / 2,
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      '& .MuiTextField-root': {
        width: '49%',
      },
    },
  },
  radioGroup: {
    marginBottom: theme.spacing(1),
    '& > .MuiFormControlLabel-root': {
      flex: '1',
    },
  },
})

export default styles
